import { FC, useCallback } from "react";
import { WidgetHeaderChipWithViewsHierarchySelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/widgets-views-hierarchy-select/WidgetHeaderChipWithViewsHierarchySelect";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { billingExplorerWidgetViewIdByWidgetIdSelector } from "@/store/dashboards/selectors/widgets/billing-explorer-widget/widget-view/billingExplorerWidgetViewIdByWidgetIdSelector";
import { SourceDataChipProps } from "@/components/pages/dashboard/components/widgets/common/widget-header/source-and-name/SourceDataChip";
import { updateBillingExplorerWidgetFromQuickActionsThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/actions/updateBillingExplorerWidgetFromQuickActionsThunk";

interface BillingExplorerWidgetHeaderViewSelectProps {
  sourceData: Omit<SourceDataChipProps, "icon" | "openIn">;
  widgetId: string;
}

export const BillingExplorerWidgetHeaderViewSelect: FC<
  BillingExplorerWidgetHeaderViewSelectProps
> = ({ widgetId, sourceData }) => {
  const dispatch = useAppDispatch();

  const viewId = useAppSelector((state) =>
    billingExplorerWidgetViewIdByWidgetIdSelector(state, widgetId),
  );

  const viewChangeHandler = useCallback(
    (id: string) => {
      dispatch(
        updateBillingExplorerWidgetFromQuickActionsThunk({
          id: widgetId,
          view_id: id,
        }),
      );
    },
    [dispatch, widgetId],
  );

  return (
    <WidgetHeaderChipWithViewsHierarchySelect
      sourceData={sourceData}
      selectedItemId={viewId}
      onChange={viewChangeHandler}
    />
  );
};
